"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2916],{

/***/ 77472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Row_Row; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Row/Row.styles.js

var _templateObject;


var Box = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Row/Row.js




var Row = function Row(_ref) {
  var StaticProps = _ref["static"],
    children = _ref.children;
  return react.createElement(Box, StaticProps, children);
};
 false ? 0 : void 0;
Row.defaultProps = {
  "static": {}
};
Row.ssr = true;
Row.displayName = 'Row';
/* harmony default export */ var Row_Row = ((0,withLayoutProps/* default */.Z)(Row));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Row/index.js


/***/ }),

/***/ 73752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchFilters_SearchFilters; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterUnique/FilterUnique.js







var FiltersUnique = function FiltersUnique(_ref) {
  var searchTerm = _ref.searchTerm,
    onClick = _ref.onClick,
    values = _ref.values,
    type = _ref.type;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var onHandleClick = function onHandleClick(e, filter) {
    e.preventDefault();
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, filter));
    onClick(e, filter);
  };
  var reviewLabelFormatter = function reviewLabelFormatter(option) {
    return (option == null ? void 0 : option.hint) ? "".concat(option == null ? void 0 : option.label, " ").concat(option.hint) : "".concat(option == null ? void 0 : option.label);
  };
  var Child = function Child(option) {
    switch (type) {
      case 'review':
        return react.createElement(Review/* default */.Z, {
          min: option == null ? void 0 : option.min,
          max: option == null ? void 0 : option.max,
          label: reviewLabelFormatter(option),
          format: "label",
          score: option == null ? void 0 : option.value
        });
      case 'attribute':
        return option == null ? void 0 : option.label;
      default:
        return option == null ? void 0 : option.label;
    }
  };
  return (values == null ? void 0 : values.length) ? react.createElement(react.Fragment, null, react.createElement(List/* default */.Z, {
    scale: "small",
    searchProperty: "label",
    disableGutters: true,
    dataSource: values,
    renderItem: function renderItem(option) {
      return react.createElement(List/* default.Radio */.Z.Radio, {
        as: "span",
        fontSize: 2,
        value: option == null ? void 0 : option.value,
        selected: option == null ? void 0 : option.selected,
        filterLabel: option == null ? void 0 : option.filterLabel,
        eventLabel: option == null ? void 0 : option.label,
        href: option == null ? void 0 : option.href,
        onChange: onHandleClick,
        position: option == null ? void 0 : option.position
      }, Child(option));
    },
    name: "radio-list-".concat(type),
    "data-testid": "unique-filters"
  })) : null;
};
 false ? 0 : void 0;
FiltersUnique.defaultProps = {
  searchTerm: '',
  type: '',
  values: []
};
FiltersUnique.ssr = true;
/* harmony default export */ var FilterUnique = ((0,withLayoutProps/* default */.Z)(FiltersUnique));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterUnique/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/index.js + 2 modules
var FilterInput = __webpack_require__(99554);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FiltersMultiple/FiltersMultiple.js









var FiltersMultiple = function FiltersMultiple(_ref) {
  var collapsedIn = _ref.collapsedIn,
    searchTerm = _ref.searchTerm,
    displaySearch = _ref.displaySearch,
    onClickCollapse = _ref.onClickCollapse,
    onClick = _ref.onClick,
    values = _ref.values;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    trigger = _useState2[0],
    setTrigger = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    filterTerm = _useState4[0],
    setFilterTerm = _useState4[1];
  (0,react.useEffect)(function () {
    setTrigger((values == null ? void 0 : values.length) >= collapsedIn);
  }, [JSON.stringify(values)]);
  var onHandleClick = function onHandleClick(e, filter) {
    e.preventDefault();
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, filter));
    onClick(e, filter);
  };
  var onHandleInputChange = function onHandleInputChange(e) {
    if (trigger) setTrigger(false);
    setFilterTerm(e.target.value);
  };
  var onHandleCollapseClick = function onHandleCollapseClick() {
    setTrigger(!trigger);
    if (!trigger) onClickCollapse();
  };
  return (values == null ? void 0 : values.length) ? react.createElement(react.Fragment, null, displaySearch && react.createElement(FilterInput/* default */.Z, {
    mb: 3,
    onChange: onHandleInputChange,
    onClearInput: function onClearInput() {
      return setFilterTerm('');
    },
    "data-testid": "filter-input"
  }), react.createElement(List/* default */.Z, {
    scale: "small",
    collapse: (values == null ? void 0 : values.length) >= collapsedIn,
    trigger: trigger,
    collapsedIn: (values == null ? void 0 : values.length) <= collapsedIn ? values == null ? void 0 : values.length : collapsedIn,
    dataSource: values,
    renderItem: function renderItem(filter) {
      return react.createElement(List/* default.Checkbox */.Z.Checkbox, {
        key: filter == null ? void 0 : filter.slug,
        as: "span",
        checked: filter == null ? void 0 : filter.selected,
        fontSize: 2,
        onClick: function onClick(e) {
          return onHandleClick(e, filter);
        },
        "data-testid": "filter-checkbox"
      }, filter == null ? void 0 : filter.label);
    },
    renderAction: (values == null ? void 0 : values.length) >= collapsedIn && react.createElement(List/* default.Action */.Z.Action, null, react.createElement(Link/* default */.Z, {
      color: "text.primary",
      fontWeight: "medium",
      fontSize: 2,
      px: 0,
      onClick: onHandleCollapseClick,
      "data-testid": "filter-action"
    }, trigger ? 'Ver todos' : 'Ver menos')),
    searchProperty: "label",
    searchTerm: filterTerm,
    sortBy: function sortBy(_ref2) {
      var selected = _ref2.selected;
      return selected ? -1 : 1;
    },
    disableGutters: true
  })) : null;
};
 false ? 0 : void 0;
FiltersMultiple.defaultProps = {
  collapsedIn: 5,
  displaySearch: false,
  onClick: function onClick() {},
  onClickCollapse: function onClickCollapse() {},
  searchTerm: '',
  values: []
};
FiltersMultiple.ssr = true;
/* harmony default export */ var FiltersMultiple_FiltersMultiple = ((0,withLayoutProps/* default */.Z)(FiltersMultiple));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FiltersMultiple/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterHierarchical/FilterHierarchical.js








var FilterHierarchical = function FilterHierarchical(_ref) {
  var onClick = _ref.onClick,
    searchTerm = _ref.searchTerm,
    values = _ref.values,
    collapsedIn = _ref.collapsedIn,
    onClickCollapse = _ref.onClickCollapse;
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    trigger = _useState2[0],
    setTrigger = _useState2[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  (0,react.useEffect)(function () {
    setTrigger((values == null ? void 0 : values.length) >= collapsedIn);
  }, [JSON.stringify(values)]);
  var onHandleClick = function onHandleClick(e, filter) {
    e.preventDefault();
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, filter));
    onClick(e, filter);
  };
  var onHandleCollapseClick = function onHandleCollapseClick() {
    setTrigger(!trigger);
    if (!trigger) onClickCollapse();
  };
  return react.createElement(List/* default */.Z, {
    scale: "small",
    disableGutters: true,
    dataSource: values,
    collapse: (values == null ? void 0 : values.length) >= collapsedIn,
    trigger: trigger,
    collapsedIn: (values == null ? void 0 : values.length) <= collapsedIn ? values == null ? void 0 : values.length : collapsedIn,
    renderItem: function renderItem(filter) {
      return react.createElement(List/* default.Item */.Z.Item, {
        key: "".concat(filter.id, "-").concat(filter.slug),
        fill: "background.primary",
        filterPosition: filter.position,
        fontSize: 2,
        textAlign: "initial",
        startIcon: filter.icon,
        as: filter.href && 'a',
        href: filter.href,
        inset: filter.inset,
        fontWeight: !filter.href && 'bold',
        onClick: function onClick(e) {
          return filter.href && onHandleClick(e, filter);
        }
      }, filter.label);
    },
    renderAction: (values == null ? void 0 : values.length) >= collapsedIn && react.createElement(List/* default.Action */.Z.Action, null, react.createElement(Link/* default */.Z, {
      color: "text.primary",
      fontWeight: "medium",
      fontSize: 2,
      px: 0,
      onClick: onHandleCollapseClick,
      "data-testid": "filter-action"
    }, trigger ? 'Ver todos' : 'Ver menos'))
  });
};
 false ? 0 : void 0;
FilterHierarchical.defaultProps = {
  collapsedIn: 5,
  onClickCollapse: function onClickCollapse() {},
  searchTerm: '',
  values: []
};
FilterHierarchical.ssr = true;
/* harmony default export */ var FilterHierarchical_FilterHierarchical = ((0,withLayoutProps/* default */.Z)(FilterHierarchical));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterHierarchical/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PriceRange/index.js + 2 modules
var PriceRange = __webpack_require__(58125);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterPrice/FilterPrice.js


var _excluded = ["searchTerm", "onApply"],
  _excluded2 = ["buildHref"];





var FilterPrice = function FilterPrice(_ref) {
  var searchTerm = _ref.searchTerm,
    onApply = _ref.onApply,
    filterProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var max = filterProps.max,
    min = filterProps.min,
    selectedMin = filterProps.selectedMin,
    selectedMax = filterProps.selectedMax;
  var handleApply = function handleApply(e, appliedRange, filter) {
    e.preventDefault();
    var buildHref = filter.buildHref,
      appliedFilter = (0,objectWithoutProperties/* default */.Z)(filter, _excluded2);
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, appliedFilter, {
      selectedMax: appliedRange.max,
      selectedMin: appliedRange.min
    }));
    onApply(e, appliedRange, filter);
  };
  return react.createElement(PriceRange/* default */.Z, {
    item: filterProps,
    max: max,
    min: min,
    initialMax: selectedMax,
    initialMin: selectedMin,
    onApply: handleApply
  });
};
 false ? 0 : void 0;
FilterPrice.defaultProps = {
  searchTerm: '',
  selectedMax: undefined,
  selectedMin: undefined
};
FilterPrice.ssr = true;
/* harmony default export */ var FilterPrice_FilterPrice = ((0,withLayoutProps/* default */.Z)(FilterPrice));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterPrice/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/index.js + 2 modules
var Accordion = __webpack_require__(50616);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/SearchFilters.styles.js


var _templateObject;


var AccordionStyled = (0,styled_components_browser_esm["default"])(Accordion/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.white',
    padding: '12px !important'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/SearchFilters.js















var SearchFilters = function SearchFilters(_ref) {
  var _data$search2, _structure$route;
  var data = _ref.data,
    structure = _ref.structure,
    _ref$static = _ref["static"],
    _ref$static$customCat = _ref$static.customCategoryFilter,
    customCategoryFilter = _ref$static$customCat === void 0 ? false : _ref$static$customCat,
    _ref$static$searchTer = _ref$static.searchTerm,
    searchTerm = _ref$static$searchTer === void 0 ? '' : _ref$static$searchTer,
    _ref$static$displayOp = _ref$static.displayOpened,
    displayOpened = _ref$static$displayOp === void 0 ? 8 : _ref$static$displayOp,
    _ref$static$displaySe = _ref$static.displaySearch,
    displaySearch = _ref$static$displaySe === void 0 ? [] : _ref$static$displaySe,
    _ref$static$removeFil = _ref$static.removeFilters,
    removeFilters = _ref$static$removeFil === void 0 ? [] : _ref$static$removeFil,
    uniqueFiltersConfig = _ref$static.uniqueFilters;
  var refs = (0,react.useRef)({});
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var query = structure.query;
  var sortFilters = function sortFilters() {
    var _data$search;
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filterBySlug = filters.reduce(function (acc, filter) {
      return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, filter.slug, filter));
    }, {});
    var baseFilters = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : _data$search.filters) || [];
    return baseFilters.reduce(function (acc, _ref2) {
      var _filterBySlug$slug, _filterBySlug$slug$va, _filterBySlug$slug2;
      var slug = _ref2.slug;
      return filterBySlug[slug] && (((_filterBySlug$slug = filterBySlug[slug]) == null ? void 0 : (_filterBySlug$slug$va = _filterBySlug$slug.values) == null ? void 0 : _filterBySlug$slug$va.length) || ((_filterBySlug$slug2 = filterBySlug[slug]) == null ? void 0 : _filterBySlug$slug2.componentType) === 'priceRange') ? [].concat((0,toConsumableArray/* default */.Z)(acc), [filterBySlug[slug]]) : acc;
    }, []);
  };
  var buildFilterFilters = function buildFilterFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _filtersParser = (0,esm/* filtersParser */.U8)({
        customCategoryFilter: customCategoryFilter,
        data: data,
        filters: filters,
        query: query,
        removeFilters: removeFilters,
        structure: structure
      }),
      attributeFilters = _filtersParser.attributeFilters,
      reviewFilters = _filtersParser.reviewFilters,
      categoryFilters = _filtersParser.categoryFilters,
      priceFilters = _filtersParser.priceFilters;
    var newParsedFilters = attributeFilters.map(function (filter) {
      var componentType = (uniqueFiltersConfig == null ? void 0 : uniqueFiltersConfig.some(function (uniqueFilterConfig) {
        return (0,esm/* hasSomeEqualProp */.dD)(filter, uniqueFilterConfig);
      })) ? 'unique' : 'multiple';
      return (0,esm_extends/* default */.Z)({}, filter, {
        componentType: componentType
      });
    });
    if (reviewFilters) {
      reviewFilters.componentType = 'unique';
      newParsedFilters.push(reviewFilters);
    }
    if (categoryFilters) {
      categoryFilters.componentType = 'hierarchical';
      newParsedFilters.push(categoryFilters);
    }
    if (priceFilters) {
      priceFilters.componentType = 'priceRange';
      newParsedFilters.push(priceFilters);
    }
    return sortFilters(newParsedFilters);
  };
  var toggleDisplayOpened = function toggleDisplayOpened(currentFilters) {
    return currentFilters.slice(0, displayOpened).reduce(function (acc, filter) {
      return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, filter.slug, true));
    }, {});
  };
  var parsedFilters = buildFilterFilters(data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : _data$search2.filters);
  var _useState = (0,react.useState)(toggleDisplayOpened(parsedFilters)),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    collapse = _useState2[0],
    collapsableSet = _useState2[1];
  var _useState3 = (0,react.useState)(parsedFilters),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    allFilters = _useState4[0],
    allFiltersSet = _useState4[1];
  var toggleCollapse = function toggleCollapse(slug) {
    var action = (collapse == null ? void 0 : collapse[slug]) ? 'close' : 'open';
    publish("productlist:filter:".concat(action));
    collapsableSet(function (prev) {
      return (0,esm_extends/* default */.Z)({}, prev, (0,defineProperty/* default */.Z)({}, slug, !(prev == null ? void 0 : prev[slug])));
    });
  };
  var updateFilters = function updateFilters() {
    var _data$search3;
    var updatedFilters = buildFilterFilters(data == null ? void 0 : (_data$search3 = data.search) == null ? void 0 : _data$search3.filters);
    allFiltersSet(updatedFilters);
  };
  (0,react.useEffect)(function () {
    updateFilters();
  }, [JSON.stringify(data)]);
  (0,react.useEffect)(function () {
    collapsableSet(toggleDisplayOpened(parsedFilters));
  }, [structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term]);
  var onFilterItemClick = function onFilterItemClick(e, filter) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: filter == null ? void 0 : filter.href,
      spa: true
    });
  };
  var onFilterPriceApply = function onFilterPriceApply(e, _ref3, filter) {
    var min = _ref3.min,
      max = _ref3.max;
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: filter == null ? void 0 : filter.buildHref(max, min),
      spa: true
    });
  };
  var renderMultiple = function renderMultiple(_ref4) {
    var type = _ref4.type,
      values = _ref4.values;
    return react.createElement(FiltersMultiple_FiltersMultiple, {
      values: values,
      searchTerm: searchTerm,
      displaySearch: displaySearch == null ? void 0 : displaySearch.includes(type),
      onClickCollapse: function onClickCollapse() {
        return (0,esm/* scrollToRef */.BC)({
          current: refs.current[type]
        });
      },
      onClick: onFilterItemClick
    });
  };
  var renderUnique = function renderUnique(_ref5) {
    var type = _ref5.type,
      values = _ref5.values;
    return react.createElement(FilterUnique, {
      values: values,
      type: type,
      searchTerm: searchTerm,
      onClick: onFilterItemClick
    });
  };
  var renderHierarchical = function renderHierarchical(_ref6) {
    var type = _ref6.type,
      values = _ref6.values;
    return react.createElement(FilterHierarchical_FilterHierarchical, {
      values: values,
      type: type,
      searchTerm: searchTerm,
      onClick: onFilterItemClick,
      onClickCollapse: function onClickCollapse() {
        return (0,esm/* scrollToRef */.BC)({
          current: refs.current[type]
        });
      }
    });
  };
  var renderPrice = function renderPrice(filterProps) {
    return react.createElement(FilterPrice_FilterPrice, (0,esm_extends/* default */.Z)({}, filterProps, {
      searchTerm: searchTerm,
      onApply: onFilterPriceApply
    }));
  };
  var renderByType = {
    hierarchical: renderHierarchical,
    multiple: renderMultiple,
    priceRange: renderPrice,
    unique: renderUnique
  };
  return react.createElement(Box/* default */.Z, {
    "data-testid": "search-filters"
  }, allFilters == null ? void 0 : allFilters.map(function (filterItem) {
    var componentType = filterItem.componentType,
      type = filterItem.type,
      slug = filterItem.slug,
      label = filterItem.label;
    return react.createElement(react.Fragment, null, react.createElement(AccordionStyled, {
      ref: function ref(element) {
        refs.current["".concat(type, "-").concat(slug)] = element;
      },
      asTitle: "p",
      key: "".concat(type, "-").concat(slug),
      title: label,
      open: collapse == null ? void 0 : collapse[slug],
      onClick: function onClick() {
        return toggleCollapse(slug);
      },
      openIcon: "ChevronDown",
      closeIcon: "ChevronUp",
      mb: 2,
      mt: 2,
      borderRadius: 10,
      "data-testid": "accordion-".concat(componentType, "-filters")
    }, renderByType[componentType](filterItem)));
  }));
};
 false ? 0 : void 0;
SearchFilters.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
SearchFilters.ssr = true;
/* harmony default export */ var SearchFilters_SearchFilters = ((0,withLayoutProps/* default */.Z)(SearchFilters));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/index.js


/***/ }),

/***/ 13288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchHeader_SearchHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchHeader/SearchHeader.styles.js

var _templateObject;


var CountLabel = styled_components_browser_esm["default"].p(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  margin-right: auto;\n"])), function (props) {
  return (0,build_esm.getTextColor)('light')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchHeader/SearchHeader.js






var SearchHeader = function SearchHeader(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var countLabel = staticProps.countLabel;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    pagination = _ref2.pagination;
  var recordsTitle = {
    label: countLabel,
    records: pagination == null ? void 0 : pagination.records
  };
  return react.createElement(Flex/* default */.Z, {
    alignContent: "space-between"
  }, (pagination == null ? void 0 : pagination.records) && react.createElement(CountLabel, null, (0,esm/* parseRecordsTitle */.LZ)(recordsTitle)));
};
 false ? 0 : void 0;
SearchHeader.defaultProps = {
  data: {},
  "static": {}
};
SearchHeader.ssr = true;
/* harmony default export */ var SearchHeader_SearchHeader = ((0,withLayoutProps/* default */.Z)(SearchHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchHeader/index.js


/***/ }),

/***/ 70134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchOrder_SearchOrder; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/index.js + 2 modules
var Select = __webpack_require__(73002);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchOrder/SearchOrder.js








var SearchOrder = function SearchOrder(_ref) {
  var _structure$route, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    sorts = _ref2.sorts;
  var selectedOption = (_structure$route = structure.route) == null ? void 0 : _structure$route.sortType;
  var selectedOrientation = (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.sortOrientation;
  var onChange = function onChange(label) {
    var _sorts$filter = sorts == null ? void 0 : sorts.filter(function (item) {
        return item.label === label;
      }),
      _sorts$filter2 = (0,slicedToArray/* default */.Z)(_sorts$filter, 1),
      sort = _sorts$filter2[0];
    if (sort) {
      var sortType = sort.type,
        sortOrientation = sort.orientation;
      publish('productlist:sort:change', {
        sort: sort
      });
      var path = (0,esm/* getCurrentPath */.Jz)({
        page: 1,
        sortOrientation: sortOrientation,
        sortType: sortType
      });
      (0,esm/* routePush */.dY)({
        path: path,
        spa: true
      });
    }
  };
  var options = sorts == null ? void 0 : sorts.reduce(function (acc, sort) {
    if (selectedOption && selectedOrientation && sort.type === selectedOption && sort.orientation === selectedOrientation) {
      return [{
        label: sort.label,
        selected: true,
        value: sort.label
      }].concat((0,toConsumableArray/* default */.Z)(acc));
    }
    return [].concat((0,toConsumableArray/* default */.Z)(acc), [{
      label: sort.label,
      selected: false,
      value: sort.label
    }]);
  }, []);
  return options ? react.createElement(Select/* default */.Z, {
    desktopMode: true,
    id: "desktop-with-label",
    textLabel: "Ordenar por",
    options: options,
    onChange: onChange
  }) : null;
};
 false ? 0 : void 0;
SearchOrder.defaultProps = {
  data: {},
  structure: {}
};
SearchOrder.ssr = true;
/* harmony default export */ var SearchOrder_SearchOrder = ((0,withLayoutProps/* default */.Z)(SearchOrder));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchOrder/index.js


/***/ }),

/***/ 33429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchRecommendation_SearchRecommendation; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js + 3 modules
var ProductList = __webpack_require__(98284);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchRecommendation/SearchRecommendation.js











var SearchRecommendation = function SearchRecommendation(_ref) {
  var _recommendation$produ, _structure$cookies, _structure$cookies$ac, _structure$route;
  var structure = _ref.structure,
    staticProps = _ref["static"];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _ref2 = structure.route || {},
    term = _ref2.term,
    filters = _ref2.filters,
    sortOrientation = _ref2.sortOrientation,
    sortType = _ref2.sortType,
    _ref2$page = _ref2.page,
    page = _ref2$page === void 0 ? 1 : _ref2$page;
  var _ref3 = (structure == null ? void 0 : structure.config) || {},
    domain = _ref3.domain;
  var _ref4 = (structure == null ? void 0 : structure.cookies) || {},
    _ref4$location = _ref4.location,
    location = _ref4$location === void 0 ? {} : _ref4$location,
    partnerId = _ref4.partnerId,
    _ref4$customerId = _ref4.customerId,
    customerId = _ref4$customerId === void 0 ? '0' : _ref4$customerId;
  var _staticProps$display = staticProps.display,
    display = _staticProps$display === void 0 ? 'list' : _staticProps$display,
    _staticProps$origin = staticProps.origin,
    origin = _staticProps$origin === void 0 ? 'doory' : _staticProps$origin,
    _staticProps$pageSize = staticProps.pageSize,
    pageSize = _staticProps$pageSize === void 0 ? 20 : _staticProps$pageSize,
    _staticProps$spa = staticProps.spa,
    spa = _staticProps$spa === void 0 ? false : _staticProps$spa,
    _staticProps$type = staticProps.type,
    type = _staticProps$type === void 0 ? 'list' : _staticProps$type,
    _staticProps$carousel = staticProps.carouselConfig,
    carouselConfig = _staticProps$carousel === void 0 ? {} : _staticProps$carousel;
  var _useRecommendation = (0,build_esm.useRecommendation)({
      customerId: customerId,
      filters: filters,
      location: location,
      partnerId: partnerId,
      sortOrientation: sortOrientation,
      sortType: sortType,
      term: term
    }),
    recommendation = _useRecommendation.recommendation;
  var productsParsed = recommendation == null ? void 0 : (_recommendation$produ = recommendation.products) == null ? void 0 : _recommendation$produ.map(function (product, index) {
    var path = product.path;
    var url = (0,esm/* parsePath */.cP)(path);
    var position = (page - 1) * pageSize + (index + 1);
    return (0,esm_extends/* default */.Z)({}, product, {
      position: position,
      url: url
    });
  });
  var eventData = {
    customer_id: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id,
    display: display,
    filters: filters,
    list: recommendation == null ? void 0 : recommendation.title,
    listPosition: 2,
    origin: origin,
    pageName: structure == null ? void 0 : structure.name,
    term: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term,
    type: 'recomendacao'
  };
  (0,react.useEffect)(function () {
    if (productsParsed) {
      publish('productlist:impression', (0,esm_extends/* default */.Z)({}, eventData, {
        products: productsParsed
      }));
    }
  }, [recommendation]);
  var handleProductView = function handleProductView(product) {
    publish('product:view', (0,esm_extends/* default */.Z)({}, eventData, {
      product: (0,esm_extends/* default */.Z)({}, product, {
        position: product.index + 1
      })
    }));
    publish('product:viewItemList', (0,esm_extends/* default */.Z)({}, eventData, product));
  };
  var handleProductClick = (0,react.useCallback)(function (e, product) {
    publish('productlist:selectItem:click', (0,esm_extends/* default */.Z)({}, eventData, product));
    publish('productlist:click', (0,esm_extends/* default */.Z)({}, product, eventData));
    if (spa) {
      e.preventDefault();
      (0,esm/* routePush */.dY)({
        path: product.url,
        spa: spa
      });
    }
  }, [recommendation.title]);
  var showcases = {
    carousel: react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
      products: productsParsed,
      displayMode: display,
      onProductView: handleProductView,
      showArrowControls: true,
      showPartialNextSlide: false,
      slidesPerView: 4,
      showControls: false,
      auto: false
    }, carouselConfig)),
    list: react.createElement(ProductList/* default */.Z, {
      onClick: handleProductClick,
      onProductView: handleProductView,
      data: productsParsed,
      displayMode: display,
      domain: domain
    })
  };
  var showcase = showcases[type];
  return react.createElement(react.Fragment, null, productsParsed && react.createElement(Box/* default */.Z, null, react.createElement(Heading/* default */.Z, {
    "data-testid": "recommendation-title",
    as: "h3",
    fontSize: [2, 5, 5, 5],
    fontWeight: "medium",
    m: "0 8px 12px"
  }, recommendation == null ? void 0 : recommendation.title), showcase));
};
 false ? 0 : void 0;
SearchRecommendation.defaultProps = {
  "static": {},
  structure: {
    config: {},
    cookies: {},
    route: {}
  }
};
SearchRecommendation.displayName = 'SearchRecommendation';
SearchRecommendation.ssr = false;
/* harmony default export */ var SearchRecommendation_SearchRecommendation = ((0,withLayoutProps/* default */.Z)(SearchRecommendation));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchRecommendation/index.js


/***/ }),

/***/ 81474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchResultsHeader_SearchResultsHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchResultsHeader/SearchResultsHeader.styles.js

var _templateObject;


var CountLabel = styled_components_browser_esm["default"].p(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"])), function (props) {
  return (0,build_esm.getTextColor)('scratched')(props);
}, function (props) {
  return (0,build_esm.themeGet)('fontSizes.1')(props);
}, function (props) {
  return (0,build_esm.themeGet)('fontWeights.bold')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchResultsHeader/SearchResultsHeader.js





var SearchResultsHeader = function SearchResultsHeader(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var countLabel = staticProps.countLabel;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    pagination = _ref2.pagination;
  var recordsTitle = {
    label: countLabel,
    records: pagination == null ? void 0 : pagination.records
  };
  return react.createElement(CountLabel, {
    "data-testid": "results-qty-label"
  }, (pagination == null ? void 0 : pagination.records) && (0,esm/* parseRecordsTitle */.LZ)(recordsTitle));
};
 false ? 0 : void 0;
SearchResultsHeader.defaultProps = {
  data: {},
  "static": {}
};
SearchResultsHeader.ssr = true;
/* harmony default export */ var SearchResultsHeader_SearchResultsHeader = ((0,withLayoutProps/* default */.Z)(SearchResultsHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchResultsHeader/index.js


/***/ }),

/***/ 90026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ searchTitle; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchTitle/searchTitle.js



var SearchTitle = function SearchTitle(_ref) {
  var _structure$route, _structure$route$filt, _data$search, _data$search$products, _data$search$products2, _getDefaultTitle;
  var structure = _ref.structure,
    staticProps = _ref["static"],
    data = _ref.data;
  var defaultTitle = staticProps.defaultTitle,
    defaultDescription = staticProps.defaultDescription,
    deniedDescription = staticProps.deniedDescription,
    allowedDescription = staticProps.allowedDescription;
  var capitalize = function capitalize(term) {
    return term == null ? void 0 : term.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  };
  var searchTerm = structure == null ? void 0 : structure.route.term;
  var filterSeller = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : (_structure$route$filt = _structure$route.filters) == null ? void 0 : _structure$route$filt.find(function (filter) {
    return filter.type === 'seller';
  })) && !searchTerm ? data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$products = _data$search.products[0]) == null ? void 0 : (_data$search$products2 = _data$search$products.seller) == null ? void 0 : _data$search$products2.description : defaultTitle;
  var capitalizedSellerTitle = capitalize(filterSeller);
  var capitalizedTerm = capitalize(searchTerm);
  var searchTermOrSeller = searchTerm ? capitalizedTerm : capitalizedSellerTitle;
  var sensitiveTerm = data == null ? void 0 : data.sensitiveTerm;
  var getCustomTitle = function getCustomTitle() {
    return sensitiveTerm.title && sensitiveTerm.title !== '' ? sensitiveTerm.title : "".concat(searchTermOrSeller, " | Resultado de Busca Interna | Magazine Luiza");
  };
  var getDefaultTitle = function getDefaultTitle() {
    var _data$seoSearchConten, _data$seoSearchConten2;
    return (data == null ? void 0 : (_data$seoSearchConten = data.seoSearchContent) == null ? void 0 : (_data$seoSearchConten2 = _data$seoSearchConten.meta) == null ? void 0 : _data$seoSearchConten2.title) || "".concat(searchTermOrSeller, " em Promo\xE7\xE3o no Magazine Luiza");
  };
  var title = sensitiveTerm && sensitiveTerm.adjustTitle ? getCustomTitle() : (_getDefaultTitle = getDefaultTitle()) !== null && _getDefaultTitle !== void 0 ? _getDefaultTitle : defaultTitle;
  var description = sensitiveTerm != null && sensitiveTerm !== undefined ? deniedDescription : allowedDescription !== null && allowedDescription !== void 0 ? allowedDescription : defaultDescription;
  return react.createElement((head_default()), null, react.createElement("title", {
    "data-testid": "meta-title"
  }, title), react.createElement("meta", {
    "data-testid": "meta-description",
    name: "description",
    content: description
  }));
};
SearchTitle.displayName = 'SearchTitle';
SearchTitle.defaultProps = {
  data: {},
  "static": {
    allowedDescription: '',
    allowedTitle: '',
    defaultDescription: '',
    defaultTitle: '',
    deniedDescription: '',
    deniedTitle: ''
  },
  structure: {
    route: {}
  }
};
 false ? 0 : void 0;
SearchTitle.ssr = true;
/* harmony default export */ var searchTitle = (SearchTitle);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchTitle/index.js


/***/ }),

/***/ 69991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SelectByRating_SelectByRating; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RatingLine/index.js + 2 modules
var RatingLine = __webpack_require__(11151);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectByRating/SelectByRating.js










var SelectByRating = function SelectByRating(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var title = staticProps.title;
  var _ref2 = data.productRating || {},
    _ref2$reviewsByRating = _ref2.reviewsByRating,
    reviewsByRating = _ref2$reviewsByRating === void 0 ? [] : _ref2$reviewsByRating,
    _ref2$general = _ref2.general,
    general = _ref2$general === void 0 ? {} : _ref2$general;
  var _ref3 = general || {},
    reviewCount = _ref3.reviewCount;
  var _ref4 = (structure == null ? void 0 : structure.route) || {},
    _ref4$filters = _ref4.filters,
    filters = _ref4$filters === void 0 ? [] : _ref4$filters;
  var reviewsByRatingData = reviewsByRating.sort(function (a, b) {
    return b.rating - a.rating;
  }).map(function (ratingReview) {
    var rating = ratingReview.rating,
      total = ratingReview.total;
    var rate = new Map([[1, 'ONE_STAR'], [2, 'TWO_STARS'], [3, 'THREE_STARS'], [4, 'FOUR_STARS'], [5, 'FIVE_STARS']]);
    return {
      href: "rating---".concat(rate.get(rating)),
      key: rating,
      selected: false,
      total: total,
      type: rate.get(rating),
      value: rating
    };
  });
  var updatedReviewsByRatingData = reviewsByRatingData.map(function (item) {
    var _rating$;
    var rating = filters.filter(function (filter) {
      return filter.type === 'rating';
    }).map(function (filter) {
      return {
        type: filter.type,
        value: filter.value
      };
    });
    if (item.type === ((_rating$ = rating[0]) == null ? void 0 : _rating$.value)) {
      return (0,esm_extends/* default */.Z)({}, item, {
        selected: true
      });
    }
    return item;
  });
  var _useState = (0,react.useState)(updatedReviewsByRatingData),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  (0,react.useEffect)(function () {
    setOptions(updatedReviewsByRatingData);
  }, [filters]);
  var handleSubmitFilter = function handleSubmitFilter(filter, type) {
    var _rating$2;
    var rating = filters.filter(function (item) {
      return item.type === 'rating';
    }).map(function (item) {
      return {
        type: item.type,
        value: item.value
      };
    });
    if (((_rating$2 = rating[0]) == null ? void 0 : _rating$2.value) !== type) {
      var path = (0,build_esm/* getCurrentPath */.Jz)({
        filters: filter.href,
        page: 1
      });
      (0,build_esm/* routePush */.dY)({
        path: path,
        spa: true
      });
    }
  };
  var _onChange = function onChange(filter, total, type) {
    if (total !== 0) {
      var newValue = options.map(function (item) {
        var same = item.value === filter.value;
        return (0,esm_extends/* default */.Z)({}, item, {
          selected: !!same
        });
      });
      setOptions(newValue);
      handleSubmitFilter(filter, type);
      publish('review:filter:click', type, {
        data: data,
        structure: structure
      });
    }
  };
  return !!(reviewsByRating == null ? void 0 : reviewsByRating.length) && !!reviewCount && react.createElement(Box/* default */.Z, {
    bg: "background.white",
    "data-testid": "select-by-rating-container"
  }, react.createElement(Text/* default */.Z, {
    pb: 3,
    fontWeight: "medium",
    fontSize: 2
  }, title), react.createElement(List/* default */.Z, {
    disableGutters: true,
    scale: "small",
    dataSource: options,
    renderItem: function renderItem(option) {
      return react.createElement(List/* default.Radio */.Z.Radio, {
        as: "span",
        p: 3,
        key: option == null ? void 0 : option.key,
        value: option == null ? void 0 : option.value,
        selected: option == null ? void 0 : option.selected,
        onChange: function onChange() {
          return _onChange(option, option == null ? void 0 : option.total, option == null ? void 0 : option.type);
        },
        fontSize: 2,
        filterLabel: option == null ? void 0 : option.value,
        href: option == null ? void 0 : option.href,
        "data-testid": "radio-button"
      }, react.createElement(RatingLine/* default */.Z, {
        as: "div",
        count: (option == null ? void 0 : option.total) <= 999 ? "".concat(option == null ? void 0 : option.total) : '+999',
        id: option == null ? void 0 : option.value,
        max: reviewCount,
        score: option == null ? void 0 : option.total,
        starColor: "#FFCC03",
        lineColor: "#0086ff",
        fontweightScore: "bold",
        width: 90,
        widthProgress: "186px",
        countColor: "black",
        columnGap: 14,
        starSize: 20,
        heightProgress: "8px",
        scoreFontSize: 2,
        pointerNone: true
      }));
    },
    name: "list-radio"
  }));
};
SelectByRating.defaultProps = {
  data: {
    productRating: {
      reviewsByRating: []
    }
  },
  "static": {
    isMobile: false,
    reviewOptions: [],
    title: ''
  },
  structure: {}
};
 false ? 0 : void 0;
SelectByRating.ssr = true;
/* harmony default export */ var SelectByRating_SelectByRating = (SelectByRating);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectByRating/index.js


/***/ })

}]);